if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';

      // grab upsells section
      this.pdpUpsellsSection = document.querySelector('.pdp-upsells pdp-upsells');

      this.productData = null;
      this.context = this.dataset.context;

      if(this.context === 'quick-add') {
        this.extractProductData();
        this.setKlayvioAddToCartEvent();
      }
    }

    extractProductData() {
      var scriptTag = this.querySelector('script[id*="quick-add-card-tracking-"]');
      if(!scriptTag) return;
      // Parse the JSON content inside the script tag
      this.productData = JSON.parse(scriptTag.textContent);
      // add current URL to the json object
      this.productData.URL = window.location.href;
    }

    setKlayvioAddToCartEvent() {
      const atcButton = this.querySelector("form[action*='/cart/add'] button[type='submit']");

      const item = this.productData;
      if (!atcButton) return;
      atcButton.addEventListener("click", function() {
        var klAjax = true;
        if (klAjax) {
          _learnq.push(['track', 'Added to Cart', item]);
          klAjax = false;
        }
      })
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.submitButton.classList.remove('added');
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      let selectedCheckboxes = [];
      //grab all selected checkboxes in upsells section
      if(this.pdpUpsellsSection){
        selectedCheckboxes = this.pdpUpsellsSection.querySelectorAll('input[type="checkbox"]:checked');
      }
      // if upsells section is present and there are selected checkboxes, add multiple products to cart and return early
      if(this.pdpUpsellsSection && selectedCheckboxes.length > 0) {

        // grab main product id
        const mainProductID = this.form.querySelector('input[name=id]').value;

        // create array of products to add to cart, initialize with main product
        const addToCartItems = [{
          id: Number(mainProductID),
          quantity: 1
        }];

        // Loop through all bundle products and find the selected swatch
        selectedCheckboxes.forEach((checkbox) => {
          const parentEl = checkbox.closest(".pdp-upsells_product");
          const swatch = parentEl.querySelector(".colour-circle.selected");
          // if swatch is selected
          // Get product id from data attribute
          const productId = swatch.dataset.productId;

          // Add product to product array with line item properties
          addToCartItems.push({
            id: Number(productId),
            quantity: 1
          });
        });

        console.log(addToCartItems)

        const items = {
          items: addToCartItems,
          sections: "cart-drawer,cart-icon-bubble",
        };

        fetch(window.Shopify.routes.root + "cart/add.js", {
          body: JSON.stringify(items),
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "xmlhttprequest",
          },
          method: "POST",
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (json) {
          const parser = new DOMParser();

          //removing current cart-drawer section and replacijng it with newly fetched one
          document.querySelector("#shopify-section-cart-drawer").remove();
          document.querySelector("main-content").insertAdjacentHTML("beforeend", json.sections["cart-drawer"]);

          // transforming response and quering the icon count bubble
          const htmlTextCartIcon = json.sections["cart-icon-bubble"];
          const htmlCartIcon = parser.parseFromString(htmlTextCartIcon, "text/html");
          const bubbleCount = htmlCartIcon.querySelector("div.cart-count-bubble");

          //selecting existing icon count bubble
          const iconCartCountEl = document.querySelector("div.cart-count-bubble");

          // if it exists remove
          if (iconCartCountEl) {
            iconCartCountEl.remove();
          }

          // inserting new icon buuble count
          if(bubbleCount) document.querySelector(".header__icon.header__icon--cart").appendChild(bubbleCount);
        })
        .catch(function (err) {
          /* uh oh, we have error. */
          console.error(err);
        })
        .finally(() => {
          // button classes
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          // opening cart-drawer
          document.querySelector("cart-drawer").classList.add("drawer", "animate", "active");

        });

        // return early
        return
      }

      this.handleErrorMessage();

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      let productGroup = this.closest('.product')?.querySelector('product-group');

      if(productGroup){

        let productGroupCurrent = productGroup.dataset.selectedType;
        let productGroupCurrentItem = productGroupCurrent.split(":");
        let productGroupType = productGroupCurrentItem[0].trim();
        let productGroupData = productGroupCurrentItem[1].trim();

        formData.set(`[properties][${productGroupType}]`, productGroupData)
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          // console.log(quickAddModal)
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);

            const productFormSubmit = document.getElementById(quickAddModal.getAttribute('data-product-form-submit'));

            if (productFormSubmit) {
              productFormSubmit.classList.add('added');
            }

          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.classList.add('added');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {

      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}